import React from 'react'
import PropTypes from 'prop-types'
import Spinner from '../common/Spinner';
import { connect } from 'react-redux'
import {getIndirectCosts} from 'actions/pulpitActions'
import { getCode5, getReport5, getCode4 } from 'actions/reportActions';
import Report5Management from './Report5Management'
import TableNestedManagement from './TableNestedManagement'
import { ColumnsGap } from 'react-bootstrap-icons';
import ReportButtons  from '../common/ReportButtons'
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
import { Document, Packer, Table, TableRow, TableCell, Paragraph, TextRun, WidthType, AlignmentType, VerticalAlign, convertMillimetersToTwip } from 'docx';
import moment from "moment";


const FinanceDataFourth = (props) => {
  const {tableData, dates, getIndirectCosts,  indirectRow, indirectLoading, indirectError, opkSelect,
    getReport5, report5, getCode5, report4, getCode4, nestedLoading}=props
  const valueConvert = (val, prec=2) => {
    if(typeof val === typeof 1) return Number(val).toFixed(prec).toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1 ').replace(".",",")
    return val
  }
  let title = "Struktura kosztów dla " + opkSelect.label
  const canBeToggled = ['dir_cost', 'koszt_dzial_medycz', 'koszt_dzial_niemedycz', 'procedural_cost','manag_cost']// 
  const rows =["Koszty bezpośrednie","Koszty pośrednie działalności medycznej","Koszty pośrednie działalności niemedycznej",
   "Koszty procedur medycznych","Koszty zarządu", "Koszt własny sprzedaży OPK"]
   const dict={"Koszty bezpośrednie":"Koszty bezpośrednie","Koszty pośrednie działalności medycznej":"Koszty pośrednie działalności medycznej",
   "Koszty pośrednie działalności niemedycznej":"Koszty pośrednie działalności niemedycznej",
   "Koszty procedur medycznych":"Koszty procedur medycznych","Koszty zarządu":"Koszty zarządu", "Koszt własny sprzedaży OPK":"Koszt własny sprzedaży"}
  const [newRowTable, setNewRowTable] = React.useState({})
  const [showRow, setShowRow]  =React.useState({})
  let table = [report5,null,null,null,null]
  React.useEffect(()=>{
    let params ={opk_number:opkSelect.value, ...dates}
    getReport5(params)
  },[])
  const handleClick = (i)=>{
    if(showRow[i]===undefined){
    // let params ={number:opk.value}
    // getIndirectCosts(params)
    if(i>0, i<5) getCode4({opk_number:opkSelect.value, number: canBeToggled[i], ...dates })
    let temp = showRow
    temp[i] = true
    setShowRow(temp)
    let temp1 = newRowTable
    temp1[i]=table[i]
    setNewRowTable(temp1)
    setRefreshRow(!refreshRow)
  }else{
    let temp2 = showRow
    temp2[i] = !showRow[i]
    setShowRow(temp2)
    setRefreshRow(!refreshRow)
  }
  }
  const [refreshRow, setRefreshRow] = React.useState(false)
 
  const [refresh, setRefresh] = React.useState(false)
  React.useEffect(()=>{
    setRefresh(!refresh)
  }, [nestedLoading])

const [showOPK, setShowOPK] = React.useState({1:{}})
  const showOPKtoggle = (opk) => {
      let temp = showOPK
      if(showOPK[1][opk] !== undefined){ //if that opk was clicked before, toggle view on that row
        temp[1][opk] = !showOPK[1][opk]
        setShowOPK(temp)
        setRefresh(!refresh)
      }
      else{ //first time for that opk -> get children from API
        let params = {
          'number': opk
        }
        params['opk_number']=opkSelect.value
        getCode5(params)

        // switch(active){
        //   case 1:
        //     getCode5(params)
        //     break;
        //   default:
        //     return 0
        // }
        temp[1][opk] = true
        setShowOPK(temp)
        setRefresh(!refresh)
      }
    }
  
  const checkData = (data,i) => {
    if(data === null) return false
    if (data.nested === undefined) return false
    if (data.nested[canBeToggled[i]] === undefined) return false
    return true
  }
  //DOC
  const getTableRow = (values, format={}, mergeCells={col:[], row: []}) => {
    let row = []
    values.forEach( (val, i) => {
      row.push(new TableCell({
        children: [
          new Paragraph({
            children: [new TextRun({ 
              text: String(val), 
              font:'Calibri', 
              bold: format.bold||(format.firstBold&&i===0), 
              color: format.textColor,
              size: format.size,
              allCaps: format.allCaps
            })],
            alignment: format.align[i]
          })
        ],
        rowSpan: mergeCells.row[i]?mergeCells.row[i]:1,
        columnSpan: mergeCells.col[i]?mergeCells.col[i]:1,
        verticalAlign: VerticalAlign.CENTER,
        shading: {
          fill: format.backgroundColor
        },
        margins: {
          marginUnitType: WidthType.DXA,
          top: 100, bottom: 100, left: 100, right: 100
        }
      }))
    })
    return row
  }
  
  const downloadDoc = () => {
    let tableRows = []
    const headerStyle = {
      bold: true, backgroundColor:'#b6b6b6', textColor: 'white', size: '22', allCaps: true,
      align: Array(5).fill(AlignmentType.CENTER)
    }
    const bodyStyle = {
      bold: false, backgroundColor:'white', textColor: 'black', size: '24', allCaps: false,
      align: [AlignmentType.LEFT].concat(Array(2).fill(AlignmentType.RIGHT))
    }
    const nestedStyle = {
      bold: false, backgroundColor:'#f4f4f4', textColor: 'black', size: '24', allCaps: false,
      align: Array(2).fill([AlignmentType.LEFT]).concat(Array(3).fill(AlignmentType.RIGHT))
    }
    const nestedStyleHeader = {
      bold: true, backgroundColor:'#f4f4f4', textColor: 'black', size: '24', allCaps: true,
      align: Array(6).fill([AlignmentType.CENTER])
    }
    const nestedStyle2 = {
      bold: false, backgroundColor:'#f4f4f4', textColor: 'black', size: '24', allCaps: false,
      align: Array(2).fill([AlignmentType.LEFT]).concat(Array(3).fill(AlignmentType.RIGHT))
    }

    // header
    tableRows.push(new TableRow({
      children: getTableRow([
        'Rodzaj i struktura kosztów',
        'Wartość kosztu [zł]',
        'Udział % w kosztach całkowitych'
      ], headerStyle, {col:[2,1,1], row: []}),
      tableHeader: true
    }))
    
    //body
    Object.entries(rows).map(([i, item]) => {
      tableRows.push(new TableRow({
        children: getTableRow([
          item,
          valueConvert(tableData[dict[item]]),
          valueConvert(tableData[dict[(item)]+' pr'])+'%'
        ], {...bodyStyle, firstBold: true, bold: !canBeToggled[i]}, {col:[2,1,1], row: []})
      }))
      
      //nested table
      if(showRow[i]){
        if(i==0){
        if(report5!==null){
          //header
            Object.entries(report5).map(([opk, item]) =>{
              if(opk!=="Suma"){
                tableRows.push(new TableRow({
                  children: getTableRow([
                    opk,
                    item['name'],
                    valueConvert(item['WARTOŚĆ KOSZTU [ZŁ]']).toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1 '),
                    valueConvert(item['UDZIAŁ W KOSZCIE CAŁKOWITYM OPK [%]'])+'%'
                  ], {...nestedStyle})                 }))
                  
                if(item['children']!==undefined && showOPK[1][opk]){
                  Object.entries(item['children']).map(([opk2, item2], i2) => {
                    tableRows.push(new TableRow({
                      children: getTableRow([
                        opk2,
                        item2['name'],
                        valueConvert(item2['WARTOŚĆ KOSZTU [ZŁ]']).toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1 '),
                        valueConvert(item2['UDZIAŁ W KOSZCIE CAŁKOWITYM OPK [%]'])+'%'
                      ], {...nestedStyle2})                 }))
                  })
                }
              }
              // else {
              //   tableRows.push(new TableRow({
              //     children: getTableRow([
              //       opk,
              //       valueConvert(item['WARTOŚĆ KOSZTU [ZŁ]']).toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1 '),
              //       valueConvert(item['UDZIAŁ W KOSZCIE CAŁKOWITYM OPK [%]'])+'%'
              //     ], {...nestedStyle, bold: true}, {col:[2,1,1], row: []})
              //   }))
              // }
            })
          }else{
            tableRows.push(new TableRow({
              children: getTableRow(['Brak danych do wyświetlenia'], 
              {...bodyStyle, backgroundColor:'white' }, {col:[4], row: []})
            }))
          }
        }else{
          if(checkData(report4, i)){
            if(report4.nested[canBeToggled[i]].length!==0){
              report4.nested[canBeToggled[i]].map((item, ind) => { 
                tableRows.push(new TableRow({
                  children: getTableRow([
                    item.code,
                    item.name,
                    valueConvert(item.koszt),
                    valueConvert(item.koszt_proc)+'%'
                  ], nestedStyle)
                }))
              })
            }else{
              tableRows.push(new TableRow({
                children: getTableRow(['Brak danych do wyświetlenia'], 
                {...bodyStyle, backgroundColor:'white' }, {col:[4], row: []})
              }))
            }
          }
        }
      }
    })

    let table = new Table({
      rows: tableRows,
      width: { size: 100, type: WidthType.PERCENTAGE}
    })

    //DOCUMENT
    let paragraphs = [
      new Paragraph({
        children:[
          new TextRun({text: title+'\n\n', font:'Calibri', bold: true, size: 26 })
        ],
        alignment: AlignmentType.JUSTIFIED,
        spacing: { after: 200 }
      }),
      table
    ]

    let doc = new Document({ 
        sections: [{
            properties: { page: { 
                size: { 
                    // height: convertMillimetersToTwip(210),
                    // width: convertMillimetersToTwip(297) 
                },
                margin: {
                    top: convertMillimetersToTwip(15),
                    right: convertMillimetersToTwip(15),
                    bottom: convertMillimetersToTwip(15),
                    left: convertMillimetersToTwip(15),
                },
            }},
            children: paragraphs
        }] 
    })

    // doc.Settings.addCompatibility().doNotExpandShiftReturn();

    Packer.toBlob(doc).then(blob =>{
      saveAs(blob, title+'.doc')
    })
  }
  const downloadCSV = () => {
    let filename = title + ".csv"
    var csv = [];
    var rows = document.querySelectorAll(`#strukturaTabela tr`);
    for (var i = 0; i < rows.length; i++) {
      if(rows[i].childElementCount>1){
        var row = [], cols = rows[i].querySelectorAll("td, th");
        for (var j = 0; j < cols.length; j++)
        // if(j===1 && i===0){row.push('KOD PROCEDURY WG KLASYFIKACJI ICD-9')} 
        // else if(j===2 && i===0){row.push('KOD PROCEDURY WG ŚWIADCZENIODAWCY')} 
        // else if(j===6 && i===0){row.push('ŁĄCZNIE JEDNOSTKOWY KOSZT NORMATYWNY W ZŁ')} 
        // else{   
          row.push(cols[j].innerText)
          // ;} 
        csv.push(row.join(";"));		}}
        csv = csv.join("\n")

    var csvFile;
    var downloadLink;
    var universalBOM = "\uFEFF";
    csvFile = new Blob(['\ufeff',csv], {type: "text/csv;charset=UTF-8"});
    downloadLink = document.createElement("a");
    downloadLink.download = filename;
    downloadLink.href = window.URL.createObjectURL(csvFile);
    downloadLink.style.display = "none";
    document.body.appendChild(downloadLink);
    downloadLink.click();
  }
  const s2ab = (s)=>{
    var buf = new ArrayBuffer(s.length);
    var view = new Uint8Array(buf);
    for (var i=0; i<s.length; i++) view[i] = s.charCodeAt(i) & 0xFF;
    return buf;
}
  const downloadXlsx = () =>{
    var wb = XLSX.utils.table_to_book(document.getElementById('strukturaTabela'), {sheet:"Struktura kosztów", raw:true});

    var ws = wb.Sheets["Struktura kosztów"];
    var range = XLSX.utils.decode_range(ws['!fullref']);
    // var merges = ws['!merges'];
    // var cell
    // if(merges) {merges.forEach(elem=>{
    //  cell =  elem.e.r +1
    //  ws[`A${cell}`].v=""
    // })}
    // for(let i=1;i<=range.e.r+1;i++){
     //  get the current sheet
    // ws[`D${i}`].z = "0.00%"; //  format the cell
    // ws[`F${i}`].z = "0.00%"; //  format the cell
    // delete ws[`D${i}`].w; // delete old formatted text if it exists
    // delete ws[`F${i}`].w; // delete old formatted text if it exists
    // XLSX.utils.format_cell(ws[`D${i}`]);
    // XLSX.utils.format_cell(ws[`F${i}`]);
    // }

        var wbout = XLSX.write(wb, {bookType:'xlsx', bookSST:true, type: 'binary'});
        let filename = title + ".xlsx"
        saveAs(new Blob([s2ab(wbout)],{type:"application/octet-stream"}), filename);
  }

  if(tableData){
    return (
      <div className=''>
        <ReportButtons downloadDoc={downloadDoc} downloadCSV={downloadCSV} downloadXlsx={downloadXlsx} color='pulpit'/>
        <table className='table table-border tablePulpit' id="strukturaTabela">
          <thead className="headerColor" style={{backgroundColor:"white"}}>
            <tr >
              <th colSpan='2'>Rodzaj i struktura kosztów</th>
              <th style={{width:"20%"}}>Wartość kosztu [zł]</th>
              <th style={{width:"20%"}}>Udział % w kosztach całkowitych</th>
            </tr>
          </thead>
          <tbody className='rt-tbody'>
          {rows.map((item, i) => {
              return (<>
              <tr key={`rep2-${i}`} className={canBeToggled[i]?'rowHover':''}>
                {canBeToggled[i]?
                <>
                  <td onClick={()=>{handleClick(i)}} className="tdTitles" style={{cursor: 'pointer'}} colSpan='2'> 
                    {showRow[i]?<i className="nc-icon nc-minimal-down" style={{marginRight: '5px',color:"rgb(69, 79, 134)"}}></i>:<i className="nc-icon nc-minimal-right" style={{marginRight: '5px', color:"rgb(69, 79, 134)"}}></i>}
                    {item}
                  </td>
                  <td className="rightAlignCell">{valueConvert(tableData[dict[item]])}</td>
                  <td className="rightAlignCell">{valueConvert(tableData[dict[(item)]+' pr'])}%</td>
                </>:<>
                  <td className="tdTitles" colSpan='2'>{item}</td>
                  <td className="rightAlignCell text-bold">{valueConvert(tableData[dict[item]])}</td>
                  <td className="rightAlignCell text-bold">{valueConvert(tableData[dict[(item)]+' pr'])}%</td>
                </>}
              </tr>
              {showRow[i] && <>
                {/* <tr><td colSpan='3' style={{padding:"0px 0px"}} >  */}
                {i===0?
                 <>{report5!==null && 
                    <Report5Management tableData={report5} showOPK={showOPK[1]} showOPKtoggle={showOPKtoggle} refresh={refresh} />
                  }</>:<>{checkData(report4, i) && <>{report4.nested[canBeToggled[i]].length!==0?
                    <TableNestedManagement tableData={report4.nested[canBeToggled[i]]} refresh={refresh}/>:
                    <i style={{marginLeft:'15px'}}>Brak danych do wyświetlenia</i>}
                  </>}</>
                }
                {/* </td></tr> */}
                </>}</>)
            })}
          </tbody>
        </table>
      </div>
    )
  }else{
    return <Spinner/>
  }
}
FinanceDataFourth.propTypes = {
  tableData: PropTypes.object
}
const mapStateToProps = state => ({
  
  indirectRow: state.pulpitReducer.indirectRow,
  indirectLoading: state.pulpitReducer.indirectLoading,
  indirectError: state.pulpitReducer.indirectError,

  report5: state.reportReducer.report5,
  report4: state.reportReducer.report4,
  nestedLoading: state.reportReducer.nestedLoading,
 
})
export default connect(mapStateToProps, {getIndirectCosts, getReport5, getCode5, getCode4 })(FinanceDataFourth)
